import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  GiCrystalBall,
  GiSunrise,
  GiMoonBats,
  GiLovers,
  GiCalendar
} from 'react-icons/gi';
import { FiArrowRight } from 'react-icons/fi';
import { useTranslation } from '../../hooks/useTranslation';
import './ServicesGrid.css';

const ServicesGrid = () => {
  const { t } = useTranslation();

  const services = [
    {
      id: 1,
      title: t('services.horoscope'),
      description: t('services.horoscopeDesc'),
      icon: GiCrystalBall,
      link: '/online-horoscope-generator',
      color: '#fbbf24'
    },
    {
      id: 2,
      title: t('services.dailyHoroscope'),
      description: t('services.dailyHoroscopeDesc'),
      icon: GiSunrise,
      link: '/horoscope',
      color: '#8b5cf6'
    },
    {
      id: 3,
      title: t('services.zodiac'),
      description: t('services.zodiacDesc'),
      icon: GiMoonBats,
      link: '/zodiac',
      color: '#ec4899'
    },
    {
      id: 4,
      title: t('services.matchMaking'),
      description: t('services.matchMakingDesc'),
      icon: GiLovers,
      link: '/match-making',
      color: '#f43f5e'
    },
    {
      id: 6,
      title: t('services.panchangService'),
      description: t('services.panchangServiceDesc'),
      icon: GiCalendar,
      link: '/panchangam',
      color: '#22c55e'
    }
  ];
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <section className="services-section section">
      <div className="container">
        <div className="section-title">
          <h2>{t('services.title')}</h2>
          <p>{t('services.subtitle')}</p>
        </div>

        <motion.div
          className="services-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {services.map((service) => (
            <motion.div key={service.id} variants={itemVariants}>
              <Link to={service.link} className="service-card">
                <div
                  className="service-icon"
                  style={{ '--service-color': service.color }}
                >
                  <service.icon />
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <span className="service-link">
                  {t('services.explore')} <FiArrowRight />
                </span>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesGrid;
